import React, {useState, useEffect} from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, Input, message, Modal, Button } from 'antd';
import FormSteps from '../Form/Form';
import {useDispatch, useSelector} from 'react-redux';
import getDatiIban from '../../../redux/actions/mock/getDatiIban';
import Immagine from '../../../components/Immagine/Immagine';

const Iban = () => {

    const dispatch = useDispatch();
    const erroreCalcoloIban = useSelector(state => state.dataReducer.datiIban);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const modalitaVerifica = useSelector(state => state.dataReducer.modello.datiPratica.modalitaVerifica);
    const [helpIban,setHelpIban] = useState(null);
    const [visibleModalIban, setVisibleModalIban] = useState(false);
    const linkFiliali = useSelector(state => state.dataReducer.documentiPdf.linkFiliali);

    const salvaStep = useSelector(state => state.dataReducer.salvaStep);
    const currentStep = useSelector(state => state.dataReducer.modello.currentStep);
    const [errorMessageIban, setErrorMessageIban] = useState(null);
    

    let messageHelpIban = !modalitaVerifica ? "Potrai modificare il tuo IBAN dopo l'invio della richiesta." : errorMessageIban ? errorMessageIban : helpIban

    const datiTokenInBank = useSelector(state => state.dataReducer.datiTokenInBank);
    const [disabledIban,setDisabledIban] = useState(false);
    useEffect( () => {
        if(datiTokenInBank) {
            setDisabledIban(setDisabledItem('iban'));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    useEffect( () => {
        if(erroreCalcoloIban.errorCode === "generico"){
            message.error(erroreCalcoloIban.errorMessage,5);
        } else if(erroreCalcoloIban.errorCode === "iban") {
            setVisibleModalIban(true);
            setErrorMessageIban(erroreCalcoloIban.errorMessage);
        } else {
            setVisibleModalIban(false);
            setErrorMessageIban(null);
        }
    },[erroreCalcoloIban]);

    useEffect(() => {
        if (salvaStep?.stepErrore === currentStep && Array.isArray(salvaStep.dati)) {
            const errore = salvaStep.dati.find(e => e.errorCode === 'iban');
            setErrorMessageIban(errore?.errorMessage || null);
        } else {
            setErrorMessageIban(null);
        }
    }, [salvaStep?.stepErrore, salvaStep?.dati, currentStep]);

    

    function controlloIban(element){
        const re = /^[a-zA-Z0-9]+$/;
        if (element.target.value === '' || re.test(element.target.value)) {
            setHelpIban(null);
            if(element.target.value.length === 27){
                dispatch(getDatiIban(element.target.value,apiPath));
            }
        }else{
            setHelpIban('Inserire solo valori alfanumerici e numerici');
            if(element.target.value.length === 27){
                dispatch(getDatiIban(element.target.value,apiPath));
            }
        }
    }

    const setDisabledItem = (field) => {
        if(datiTokenInBank) {
            let elem = datiTokenInBank.find(item => item.field === field);
            if(elem) {
                return !JSON.parse(elem.editable);
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    function closeModalIban(){
        setVisibleModalIban(false);
    }

    return (
        <div className={stylesForm.Form}>
            <HeaderStep titolo='Riferimenti bancari' sottotitolo ='Ti chiediamo di inserire l’IBAN relativo al tuo conto corrente' />
            
            <FormSteps formId="step3" bloccoAvanzamento={errorMessageIban || helpIban}>

                <Form.Item name="iban" help={errorMessageIban || null}  validateStatus={errorMessageIban ? 'error' : ''}
               
                    rules={[
                    {
                        required: true,
                        message: 'Inserisci il tuo IBAN!',
                    }
                    ]}
                >
                    <Input disabled={!modalitaVerifica || disabledIban} onChange={controlloIban} minLength='26' maxLength='27' placeholder='iban' suffix={<label className={stylesForm.floatingLabel} htmlFor="iban">IBAN*</label>}/>
                </Form.Item>

            </FormSteps>


            <Modal onCancel={closeModalIban} open={visibleModalIban} closeIcon={<Immagine urlImage={'close-modal.svg'} name='close' />} >
                <h2>IBAN non riconosciuto!</h2>
                <p>Il codice IBAN inserito sembra non essere di una Banca convenzionata con PrestiPay, Controlla l'IBAN inserito o recati nella filiale più vicina per maggiori informazioni.</p>
                <Button onClick={closeModalIban} className={`${stylesForm.ButtonCCB} ${stylesForm.ButtoGradient}`}>Controlla IBAN</Button>
                <a href={linkFiliali} target="_blank" rel="noopener noreferrer" className={`${stylesForm.ButtonCCB} ${stylesForm.ButtoWhite}`}>Cerca la filiale più vicina</a>
            </Modal>


        </div>
    )
}

export default Iban;